/* globals $:false */

import SimpleMDE from 'simplemde';

import utils from '@cob/ui-genesis/cob.utils.js';

// args:
// * `confs`: the field configuration
//
// confs:
// * `id`: the input attr id
// * `cssClasses`: A string space separated with a list of css classes to add to the input
// * `readonly`: true or false. Defaults to false
// * `valueChanged(newValue)`: Invoked when a user changes the value
//
// see https://github.com/sparksuite/simplemde-markdown-editor for the available options
var Markdown = function(core, confs) {

    var _$editorWrapper,
        _simplemde,
        _lastValue,
        _previewResizerHandle;

    var _confs = {
        id: core.locallyUniqueId(),
        fieldDefinition: {name: ""},
        cssClasses: undefined,
        readonly: false,
        valueChanged: undefined,

        spellChecker: false,
        status: false,
        // The toolbar icons (fa, fa-*) come with the product's Font Awesome, instead of SimpleMDE downloading it from a CDN
        autoDownloadFontAwesome: false,
        toolbar: ["preview","side-by-side","fullscreen","|",
                  "bold", "italic", "heading","horizontal-rule","|",
                  "code","quote","unordered-list","ordered-list","table","|",
                  "link","image","|",
                  "guide"]

    };

    utils.extend(_confs, confs, true);

    if (_confs.readonly) {
        _confs.toolbar = ["fullscreen"];
    }

    var _setValue = function(value) {
        if (_lastValue !== value) {
            _lastValue = value;

            if (_confs.valueChanged) {
                _confs.valueChanged(value);
            }
        }

    };

    var _onResize = $.throttle(function() {
        _simplemde.codemirror.refresh()
    }, 100);

    var _onValueChange = function() {
        _setValue(_simplemde.value());
    };

    var _translateButtonTitles = function() {

        Object.keys(_simplemde.toolbarElements).forEach(function(el) {
            var title = _simplemde.toolbarElements[el].title;
            var titleNotToChangeSuffixPart = title.indexOf(" (") >= 0 ? title.substring(title.indexOf(" (")) : "";
            var translation = core.translateString('recordm.instances', 'instance.field.markdown.' + el);
            if (translation) {
                _simplemde.toolbarElements[el].title = translation + titleNotToChangeSuffixPart;
            }
        })
    };


    var _render = function() {
        var $html = $([
            '<div id="' + core.locallyUniqueId() + '" class="inline markdown-container field-value cob-field-value">',
            '    <textarea id="f' + _confs.id + '" class="hidden js-markdown-text"  placeholder="' + _confs.fieldDefinition.name + '"></textarea>',
            '</div>'
        ].join(''));


        _$editorWrapper = $html;
        if (_confs.cssClasses) {
            _$editorWrapper.addClass(_confs.cssClasses);
        }


        // requires the DOM element and not the jquery object
        _confs.element = $html.find("textarea").get(0);

        //noinspection JSUnresolvedFunction
        _simplemde = new SimpleMDE(_confs);
        _translateButtonTitles();

        if (_lastValue) {
            _simplemde.value(_lastValue);
            _simplemde.togglePreview();
        }

        if (_confs.readonly) {
            _simplemde.togglePreview();

        } else {
            _simplemde.codemirror.on('change', _onValueChange);
        }

        $(window).on('resize', _onResize);

        _previewResizerHandle = setInterval(() => {
           const $scroll = $html.find('.CodeMirror-scroll')
           const currentH = parseInt($scroll.css('min-height'), 10)

           if(_simplemde.isPreviewActive()){

              const $preview = $html.find('.editor-preview-active')
              const targetH = $preview[0].scrollHeight - 20

              if(currentH < targetH) $scroll.css('min-height', $preview[0].scrollHeight - 20)

           } else {
              // back to the default
              if(currentH !== 100) $scroll.css('min-height', 100)
           }
        }, 1000)

        return $html;
    };

    var _clearError = function() {
        _$editorWrapper.find('.CodeMirror-wrap').removeClass("error");
    };

    var _showError = function() {
        _$editorWrapper.find('.CodeMirror-wrap').addClass("error");
    };

    var _destroy = function() {
        $(window).off('resize', _onResize);
        clearInterval(_previewResizerHandle)
    };

    return {
        render: _render,
        destroy: _destroy,

        clearError: _clearError,
        showError: _showError,

        setValue: function(value) {
            const val = Array.isArray(value) ? value.join() : value;
            // Notify that this field has a new value because
            // I want to update the $auto.join and other fields...
            _setValue(val);

            // se já está inicializado
            if(typeof _simplemde !== 'undefined'){
               _simplemde.value(val);
               if(_simplemde.isPreviewActive()){
                  // we toggle 2 times to force an update on the preview
                  _simplemde.togglePreview()
                  _simplemde.togglePreview()
               }
            }
        },
        getValue: function() {
            return _simplemde ? _simplemde.value() : undefined;
        },

        disableSelf: function(){
           if (_simplemde && !_simplemde.isPreviewActive()) _simplemde.togglePreview();

           _$editorWrapper.find('.editor-toolbar').addClass("hidden");
        },
        enableSelf: function(){
            _$editorWrapper.find('.editor-toolbar').removeClass("hidden");
        }
    }
};

export default Markdown;
